import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Location } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthService } from '../../states/auth/services/auth.service';
import { LocalizedStrings } from '../configurations/LocalizedStrings';

@Injectable()
export class ServerErrorInterceptor implements HttpInterceptor {
  private location = inject(Location);
  private authService = inject(AuthService);

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          // Skip sign-out redirect if the failing request is /login or /logout
          if (
            request.url.endsWith('/login') ||
            request.url.endsWith('/logout')
          ) {
            return throwError(() => error);
          }

          // Use Location (the real browser URL) rather than Router.url:
          // during app bootstrap the router has not navigated yet, so
          // Router.url is still '/' and the intended address would be lost.
          this.authService.signOut(
            this.location.path(true) || undefined,
            false,
          );
          return throwError(
            () => new Error(LocalizedStrings.RefreshTokenError),
          );
        } else if (error.status === 500) {
          return throwError(() => new Error(LocalizedStrings.ServerError));
        } else {
          return throwError(() => error);
        }
      }),
    );
  }
}
